<template>
  <div class="bg-light min-vh-100">
    <main class="container">
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <div class="card shadow-sm">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center mb-2 flex-wrap gap-2">
                <h1 class="h4 mb-0">Customers</h1>
                <button v-if="isSupervisor" class="btn btn-primary btn-sm" @click="$router.push({ name: 'CreateCustomer' })">
                  New Customer
                </button>
              </div>
              <p class="help mb-3">Manage customer records.</p>

              <div v-if="loading" class="text-center py-5">
                <div class="spinner-border" role="status"></div>
              </div>

              <div v-else>
                <div v-if="error" class="alert alert-danger py-2">{{ error }}</div>

                <!-- Search -->
                <div class="mb-3">
                  <input
                    v-model="search"
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Search customers..."
                  />
                </div>

                <div v-if="filteredCustomers.length === 0" class="text-muted">
                  No customers found.
                </div>

                <div v-else class="table-responsive">
                  <table class="table table-sm align-middle">
                    <thead class="table-light">
                      <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th class="text-end">Orders</th>
                        <th class="text-end">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="c in filteredCustomers" :key="c.customer_id">
                        <td>{{ c.customer_name }}</td>
                        <td>{{ c.email || "—" }}</td>
                        <td>{{ c.phone || "—" }}</td>
                        <td class="text-end">{{ c.order_count }}</td>
                        <td class="text-end">
                          <button
                            class="btn btn-outline-secondary btn-sm"
                            @click="$router.push({ name: 'CustomerDetail', params: { id: c.customer_id } })"
                          >
                            View
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { APIService } from "../http/APIService";

export default {
  name: "CustomersList",
  data() {
    return {
      customers: [],
      loading: false,
      error: null,
      search: "",
      api: new APIService(),
    };
  },
  computed: {
    isSupervisor() {
      try {
        const raw = localStorage.getItem("currentUser");
        if (!raw) return false;
        const user = JSON.parse(raw);
        const role = (user.role || "").toLowerCase();
        return role === "supervisor" || role === "admin";
      } catch {
        return false;
      }
    },
    filteredCustomers() {
      const q = (this.search || "").trim().toLowerCase();
      if (!q) return this.customers;
      return this.customers.filter((c) => {
        return (
          (c.customer_name || "").toLowerCase().includes(q) ||
          (c.email || "").toLowerCase().includes(q) ||
          (c.phone || "").toLowerCase().includes(q)
        );
      });
    },
  },
  created() {
    this.fetchCustomers();
  },
  methods: {
    async fetchCustomers() {
      this.loading = true;
      this.error = null;
      try {
        const accessToken = localStorage.getItem("accessToken");
        const res = await this.api.getCustomers(accessToken);
        this.customers = res.data || [];
      } catch {
        this.error = "Unable to load customers.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
